import { Reveal } from "./Reveal";

const FAQS = [
  {
    q: "What is included in your end-to-end service?",
    a: "We manage spatial planning, 3D visualization, material selection, civil and electrical coordination, modular joinery, custom furniture fabrication, on-site supervision, and final styling.",
    testId: "faq-item-1",
  },
  {
    q: "How do online consultations work if I am not located nearby?",
    a: "You share your floor plans, photographs, and lifestyle preferences. We deliver comprehensive 3D views, scaled working drawings, and a precise material purchase guide that your local contractor can follow seamlessly.",
    testId: "faq-item-2",
  },
  {
    q: "Do you work on commercial spaces like cafes and offices?",
    a: "Yes, we design retail boutiques, cafes, and creative office spaces with the same warmth, functional durability, and brand-aligned design philosophy.",
    testId: "faq-item-3",
  },
];

export const Faq = () => (
  <section id="faq" className="py-24 px-6 md:px-10 bg-[#FAF6F0] border-b border-[#0D2121]/10" data-testid="faq-section">
    <div className="max-w-4xl mx-auto space-y-12">
      <Reveal className="text-center space-y-3">
        <span className="text-xs uppercase tracking-widest text-[#c88c2a] font-semibold">Answers</span>
        <h2 className="font-display text-3xl sm:text-4xl text-[#0D2121]">Common Questions</h2>
      </Reveal>

      <div className="space-y-6">
        {FAQS.map((faq, i) => (
          <Reveal key={faq.q} delay={i * 80}>
            <div className="p-6 bg-[#F4EDE2] border border-[#0D2121]/10" data-testid={faq.testId}>
              <h3 className="font-display text-lg text-[#0D2121] font-semibold">{faq.q}</h3>
              <p className="text-[#7A6F66] text-sm mt-2 leading-relaxed">{faq.a}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
